var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{vueAppClasses: _vm.vueAppClasses, mobile: _vm.mobile},attrs:{"id":"app"}},[_c('div',{ref:"result"}),_c('router-view',{on:{"setAppClasses":_vm.setAppClasses}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }